import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import Cronograma from "../components/Cronograma";
import PapelDelegadosSeccionais from "../components/PapelDelegadosSeccionais";
import PorQueVotar from "../components/PorQueVotar";
import Documentos from "../components/Documentos";
import Candidatos from "../components/Candidatos";

function Home() {

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scrollTo");

    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100); // delay pequeno ajuda
      }
    }
  }, [location]);

  // Função para verificar se é exatamente 12-09-2025 às 17:00
  // Versão alternativa - considerando dias anteriores também
  const verificarHorarioExato = () => {
    const date = new Date();
    const dataLimite = new Date('2025-10-01T09:00:00-03:00');

    // Mostra até chegar exatamente às 17:00 do dia 12-09-2025
    return date >= dataLimite;

  };

  const candidatos = verificarHorarioExato();

  return (
    <div>
      <section id="hero"><Hero /></section>
      <section id="papel-delegados" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]"><PapelDelegadosSeccionais /></section>
      <section id="porque-votar" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]"><PorQueVotar /></section>
      <section id="comovotar" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]"> </section>
      <section id="candidatos" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]">  {candidatos ? (
        <Candidatos />
      ) : (
        <></>
      )}
      </section>
      <section id="cronograma" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]"><Cronograma /></section>
      <section id="cronograma" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]">{/*<Seccionais /> Removido e colocado no site publico*/}</section>

      <section id="documentos" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]"><Documentos /></section>
    </div>
  );
}

export default Home;
